import { useMutation } from "@tanstack/react-query";
import api from "../api";

interface AssignTicketPayload {
  pikitup_ticket_id: number;
  assignee_id?: number; // optional → assign to self if not provided
  scheduled_date?: string; // ISO format (YYYY-MM-DD)
  schedule_time_of_day?: "morning" | "evening";
}

interface AssignTicketResponse {
  statusCode: number;
  message: string;
}

const assignTicket = async (
  payload: AssignTicketPayload
): Promise<AssignTicketResponse> => {
  const { data } = await api.post<AssignTicketResponse>(
    "/tickets/assign/v1",
    payload
  );
  return data;
};

export const useAssignTicket = () =>
  useMutation({
    mutationFn: assignTicket,
  });
